import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./BrandSection.module.css";
import ValueItem from "./ValueItem";
import {
  faAnglesUp,
  faBusinessTime,
  faHandshake,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";
import { useI18n } from "../../../i18n/I18nContext";

const BrandSection = () => {
  const { copy } = useI18n();
  const heroCopy = copy.home.hero;

  return (
    <div className={Style["brand-section-wrapper"]}>
      <div className={Style["brand-section-content"]}>
        <div className={Style["motto-container"]}>
          <h1>{heroCopy.title}</h1>
          <div>
            <div className={Style["delimiter"]}></div>
            <h2>{heroCopy.subtitle}</h2>
          </div>
        </div>
        <div className={Style["values-container"]}>
          <div className={Style["arrows"]}>
            <FontAwesomeIcon icon={faAnglesUp} size="4x" color="#FFDBCB" />
          </div>
          <div className={Style["values-list"]}>
            <ValueItem
              text={heroCopy.values[0]}
              icon={faBusinessTime}
            />
            <ValueItem text={heroCopy.values[1]} icon={faPeopleGroup} />
            <ValueItem text={heroCopy.values[2]} icon={faHandshake} />
          </div>
        </div>
      </div>

      <div className={Style["image-container"]}></div>
    </div>
  );
};

export default BrandSection;
